import { IFormStyles } from 'schema/generator/FormSchema';

import { checkboxFieldStyles } from 'components/molecules/form/CheckboxField';
import { radioFieldStyles } from 'components/molecules/form/RadioField';

export const defaultStyles: IFormStyles = {
  form: {
    container: {
      padding: 4,
    },
    title: {
      size: 'lg',
      marginBottom: 4,
    },
    // fieldSpacing: '1rem',
    buttonGroup: {
      columnGap: '.5rem',
      display: 'grid',
      margin: '1.5rem 0',
    },
    submitButton: {
      size: 'sm',
      width: '100%',
    },
    cancelButton: {
      size: 'square',
      width: '100%',
    },
  },
  checkboxField: checkboxFieldStyles,
  radioField: radioFieldStyles,
};
